export const ENDPOINTS = [
    {
      name: "Mainnet",
    },
    {
      name: "Rinkeby",
    },
  ];